var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as Utils from '@datocms/rest-client-utils';
import BaseResource from '../../BaseResource';
var Workflow = /** @class */ (function (_super) {
    __extends(Workflow, _super);
    function Workflow() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Create a new workflow
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/workflow/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Workflow.prototype.create = function (body) {
        return this.rawCreate(Utils.serializeRequestBody(body, {
            type: 'workflow',
            attributes: ['name', 'api_key', 'stages'],
            relationships: [],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Create a new workflow
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/workflow/create
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Workflow.prototype.rawCreate = function (body) {
        return this.client.request({
            method: 'POST',
            url: '/workflows',
            body: body,
        });
    };
    /**
     * Update a workflow
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/workflow/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Workflow.prototype.update = function (workflowId, body) {
        return this.rawUpdate(Utils.toId(workflowId), Utils.serializeRequestBody(body, {
            id: Utils.toId(workflowId),
            type: 'workflow',
            attributes: ['name', 'api_key', 'stages'],
            relationships: [],
        })).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Update a workflow
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/workflow/update
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Workflow.prototype.rawUpdate = function (workflowId, body) {
        return this.client.request({
            method: 'PUT',
            url: "/workflows/".concat(workflowId),
            body: body,
        });
    };
    /**
     * List all workflows
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/workflow/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Workflow.prototype.list = function () {
        return this.rawList().then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * List all workflows
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/workflow/instances
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Workflow.prototype.rawList = function () {
        return this.client.request({
            method: 'GET',
            url: '/workflows',
        });
    };
    /**
     * Retrieve a workflow
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/workflow/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Workflow.prototype.find = function (workflowId) {
        return this.rawFind(Utils.toId(workflowId)).then(function (body) {
            return Utils.deserializeResponseBody(body);
        });
    };
    /**
     * Retrieve a workflow
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/workflow/self
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Workflow.prototype.rawFind = function (workflowId) {
        return this.client.request({
            method: 'GET',
            url: "/workflows/".concat(workflowId),
        });
    };
    /**
     * Delete a workflow
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/workflow/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Workflow.prototype.destroy = function (workflowId) {
        return this.rawDestroy(Utils.toId(workflowId));
    };
    /**
     * Delete a workflow
     *
     * Read more: https://www.datocms.com/docs/content-management-api/resources/workflow/destroy
     *
     * @throws {ApiError}
     * @throws {TimeoutError}
     */
    Workflow.prototype.rawDestroy = function (workflowId) {
        return this.client.request({
            method: 'DELETE',
            url: "/workflows/".concat(workflowId),
        });
    };
    Workflow.TYPE = 'workflow';
    return Workflow;
}(BaseResource));
export default Workflow;
//# sourceMappingURL=Workflow.js.map